import React from 'react';
import { classNames } from '@panwds/react-ui';

const Footer = (props) => {
    const className = classNames("tw-sticky tw-bottom-0");
    return (React.createElement("div", { role: "rowgroup", style: { zIndex: 1 }, ...props, className: className }));
};

export { Footer };
//# sourceMappingURL=Footer.esm.js.map
